export default __webpack_public_path__ + "static/media/china.6e0aea53.png";